export default __webpack_public_path__ + "static/ansiedad-f33d9bd483b317eab43bba068982d18f.png";